import axios from "axios";

import { Toast } from "../../util/Toast";
import {
  CLEAR_IP_ACCOUNT_LOOKUP,
  IP_ACCOUNT_LOOKUP_FAILURE,
  IP_ACCOUNT_LOOKUP_REQUEST,
  IP_ACCOUNT_LOOKUP_SUCCESS,
  IP_MANAGEMENT_FAILURE,
  IP_MANAGEMENT_REQUEST,
  IP_MANAGEMENT_SUCCESS,
} from "./types";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.message || error.message || fallback;

const requireSuccessfulResponse = (response) => {
  if (!response.data.status) {
    throw new Error(response.data.message || "The request could not be completed.");
  }
  return response.data.data;
};

const mutateIpManagement = (key, request, successMessage) => async (dispatch) => {
  dispatch({ type: IP_MANAGEMENT_REQUEST, payload: key });
  try {
    const data = requireSuccessfulResponse(await request());
    dispatch({ type: IP_MANAGEMENT_SUCCESS, payload: data });
    Toast("success", successMessage);
    return true;
  } catch (error) {
    const message = getErrorMessage(error, "Unable to update IP Management.");
    dispatch({ type: IP_MANAGEMENT_FAILURE, payload: { key, message } });
    Toast("error", message);
    return false;
  }
};

export const getIpManagement = () => async (dispatch) => {
  dispatch({ type: IP_MANAGEMENT_REQUEST, payload: "load" });
  try {
    const data = requireSuccessfulResponse(await axios.get("ipManagement"));
    dispatch({ type: IP_MANAGEMENT_SUCCESS, payload: data });
  } catch (error) {
    const message = getErrorMessage(error, "Unable to load IP policies.");
    dispatch({ type: IP_MANAGEMENT_FAILURE, payload: { key: "load", message } });
    Toast("error", message);
  }
};

export const updateIpDefaultLimit = (maxAccounts) =>
  mutateIpManagement(
    "default",
    () => axios.post("ipManagement/default-limit", { maxAccounts }),
    "Default registration limit updated.",
  );

export const saveIpOverride = (id, payload) =>
  mutateIpManagement(
    "override",
    () =>
      id
        ? axios.put(`ipManagement/overrides/${id}`, payload)
        : axios.post("ipManagement/overrides", payload),
    id ? "IP override updated." : "IP override created.",
  );

export const deleteIpOverride = (id) =>
  mutateIpManagement(
    `delete-override-${id}`,
    () => axios.delete(`ipManagement/overrides/${id}`),
    "IP override removed.",
  );

export const createBlockedIp = (payload) =>
  mutateIpManagement(
    "block",
    () => axios.post("ipManagement/blocked-ips", payload),
    "IP address blocked from login and signup.",
  );

export const deleteBlockedIp = (id) =>
  mutateIpManagement(
    `unblock-${id}`,
    () => axios.delete(`ipManagement/blocked-ips/${id}`),
    "IP address unblocked.",
  );

export const updateRegistrationEmailProviders = (allowedDomains) =>
  mutateIpManagement(
    "email-providers",
    () => axios.post("ipManagement/email-providers", { allowedDomains }),
    "Registration email providers updated.",
  );

export const getAccountsForIp = (ip) => async (dispatch) => {
  dispatch({ type: IP_ACCOUNT_LOOKUP_REQUEST });
  try {
    const data = requireSuccessfulResponse(
      await axios.get("ipManagement/accounts", { params: { ip } }),
    );
    dispatch({ type: IP_ACCOUNT_LOOKUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: IP_ACCOUNT_LOOKUP_FAILURE,
      payload: getErrorMessage(error, "Unable to load accounts for this IP."),
    });
  }
};

export const clearIpAccountLookup = () => ({ type: CLEAR_IP_ACCOUNT_LOOKUP });
